import type { JSX } from '@builder.io/qwik';
import { component$, Slot } from '@builder.io/qwik';
import SectionHeader from './SectionHeader';
import Section from './Section';
import type { AuthorRailBlockInterface } from '~/types/AppData/PageBuilder/AuthorRailBlockInterface';
import AnalyticsContainer from '~/components/Shared/Analytics/AnalyticsContainer';
import { getOneIndexing } from '~/utilities/getOneIndexing';

export default component$<
  AuthorRailBlockInterface['props'] & { index: number }
>(({ title, index }): JSX.Element => {
  return (
    <AnalyticsContainer
      amount_of_articles={4}
      component_name={`Author Rail-Section-${getOneIndexing(index)}`}
      component_type='AuthorRail'
      component_placement={getOneIndexing(index)}
    >
      {/* Section will handle one-indexing */}
      <Section index={index}>
        <SectionHeader title={title} showQuote showDivider index={index} />
        <div class='flex flex-col md:flex-row gap-3.5'>
          <Slot />
        </div>
      </Section>
    </AnalyticsContainer>
  );
});
